import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
export const buildTicketPubsubChannel = ({
  ticketId
}) => {
  const env = enviro.isProd() ? 'prod' : 'qa';
  const portalId = PortalIdParser.get() || 0;
  return `${env}.messages.object-${portalId}:0-5:${ticketId}`;
};